import { tags } from '@/constants/Tags';
import { GlobalContext } from '@/shared/GlobalContext/GlobalContext';
import { NavigationContext } from '@/shared/NavigationContext/NavigationContext';
import { useContext, useEffect } from 'react';

export default function useTagsFilter({ currentTheme }) {
  const navigationContext = useContext(NavigationContext);
  const globalContext = useContext(GlobalContext);

  useEffect(() => {
    if (globalContext.state.selectedLanguage == 'fr') {
      navigationContext.actions.setSelectedTagId(null);
    }
  }, [globalContext.state.selectedLanguage]);

  useEffect(() => {
    if (currentTheme && navigationContext.state.selectedTagId) {
      const currentThemeTag = currentTheme.themeTags?.find(
        (themeTag) => themeTag.tagId == navigationContext.state.selectedTagId
      );
      if (!currentThemeTag) {
        navigationContext.actions.setSelectedTagId(null);
      }
    }
  }, [currentTheme, navigationContext.state.selectedTagId]);

  return {
    filterVisible:
      globalContext.state.selectedLanguage == 'es' &&
      process.env.NEXT_PUBLIC_TAGS_ENABLED,
    disabledTagIds: getDisabledTags(currentTheme),
  };
}

function getDisabledTags(theme) {
  if (!theme) {
    return [];
  }

  const enabledTagIds = [
    'all',
    ...(theme.themeTags?.map((themeTag) => themeTag.tagId) || []),
  ];

  return tags
    .map((tag) => tag.id)
    .filter((tag) => !enabledTagIds.includes(tag));
}
